// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f65ffb0","453":"b2e0cbbb","455":"db9c6252","977":"3b991094"}[chunkId] + ".chunk.js";
};